import React, { ReactNode } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Button,
  Typography,
} from '@mui/material';
import { PersonOff } from '@mui/icons-material';
import {
  IBrand,
  ICoupon,
  ITechnician,
  IUser,
} from '../../utils/entities/interface';

interface ModalConfirmationProps {
  open: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
  selectedItem: IUser | ITechnician | ICoupon | IBrand | null;
  entityName?: string;
  icon?: ReactNode;
}

export const ModalConfirmation = ({
  open,
  handleClose,
  selectedItem,
  handleConfirm,
  entityName = 'user',
  icon,
}: ModalConfirmationProps) => {
  const isActive = selectedItem
    ? 'isActive' in selectedItem
      ? selectedItem.isActive
      : selectedItem.status == 'AVAILABLE'
        ? true
        : false
    : undefined;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      sx={{ borderRadius: 4 }}
      PaperProps={{
        sx: {
          borderRadius: 4,
          overflow: 'hidden',
        },
      }}
    >
      <Box
        sx={{
          border: '1px solid #7B1FA2',
          borderRadius: 4,
          overflow: 'hidden',
        }}
      >
        <DialogContent
          sx={{
            backgroundColor: '#181818',
            padding: 4,
            textAlign: 'center',
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: '50%',
              border: '2px solid #7B1FA2',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto',
              mb: 3,
            }}
          >
            {icon || <PersonOff sx={{ fontSize: 40, color: 'black' }} />}
          </Box>

          <Typography variant="h6" sx={{ color: 'white', mb: 2 }}>
            {`Are you sure you want to ${isActive ? 'disable' : 'enable'} this ${entityName}?`}
          </Typography>
        </DialogContent>

        <DialogActions
          sx={{
            backgroundColor: '#181818',
            display: 'flex',
            justifyContent: 'center',
            gap: 2,
            pb: 3,
          }}
        >
          <Button variant="outlined" color="inherit" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color={isActive ? 'error' : 'success'}
            onClick={handleConfirm}
          >
            {isActive ? 'Disable' : 'Enable'}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};
